/* Shared analytics bridge for Seamless theme features.
   ES2019 only (FB/IG in-app WebViews) — no optional chaining / nullish coalescing.

   One event reaches three sinks, because each needs a different shape:
     - dataLayer  gets a dotted name  ("bundle_offer.impression") for GTM
     - gtag/GA4   gets an underscored name — GA4 rejects dots in event names —
                  scoped with send_to so it lands in GA4 and not the AW-/MC- tags
     - Clarity    gets a custom event (timeline marker) plus a session tag so the
                  recordings and heatmaps can be filtered by it

   This is the pattern sfTrack() in size-finder.js established; it lives here so
   new features call one helper instead of each re-implementing the bridge.
   size-finder.js still has its own copy — migrating it is a separate change,
   since it's working and shipping analytics today.

   Analytics must never break a feature: every sink is inside one try/catch and
   failures are swallowed deliberately. That is the whole contract of this file. */
(function () {
  var GA4_MEASUREMENT_ID = 'G-QRS2CB99T4';

  window.seamlessTrack = function (namespace, name, params) {
    try {
      var payload = params || {};

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        Object.assign({ event: namespace + '.' + name }, payload)
      );

      if (typeof window.gtag === 'function') {
        window.gtag(
          'event',
          namespace + '_' + name,
          Object.assign({ send_to: GA4_MEASUREMENT_ID }, payload)
        );
      }

      if (typeof window.clarity === 'function') {
        window.clarity('event', namespace + '_' + name);
        window.clarity('set', namespace, name);
      }
    } catch (err) {
      /* Deliberate: a broken or blocked analytics sink must never take a
         storefront feature down with it. */
    }
  };
})();
